
export const PUSH_TOAST_MESSAGE = 'PUSH_TOAST_MESSAGE';
export const pushToastMessage = toastData => ({
  type: PUSH_TOAST_MESSAGE,
  toastData: toastData
});
